import { environment } from 'src/environments/environment';
import { permissionEntity } from '../constants/permission';
import JSZip from 'jszip';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
interface FormControls {
  [key: string]: {
    invalid: boolean;
  };
}
export function filterValue(
  passedArray: any[],
  passedControl,
  passedReplaySubject
) {
  if (!passedArray) {
    return;
  }
  // get the search keyword
  let search = passedControl.value;

  if (!search) {
    passedReplaySubject.next(passedArray.slice());
    return;
  } else {
    search = search.toLowerCase();
  }
  // filter the banks
  passedReplaySubject.next(
    passedArray.filter(
      (supervisersName) =>
        supervisersName?.name?.toLowerCase().indexOf(search) > -1
    )
  );
}

export function filterValueWithSeletedValues(
  passedArray: any[],
  passedControl,
  passedReplaySubject,
  idsToPush?: string[]
) {
  if (!passedArray) return;

  // Step 1: Extract search value
  let search = passedControl?.value;

  // Step 2: Prepare filtered array
  let filteredArray: any[] = [];

  if (!search) {
    filteredArray = passedArray.slice();
  } else {
    search = search.toLowerCase();
    filteredArray = passedArray.filter((item) =>
      item?.name?.toLowerCase().includes(search)
    );
  }

  // Step 3: Optionally include items by ID
  if (Array.isArray(idsToPush) && idsToPush.length > 0) {
    const idsAlreadyIncluded = new Set(filteredArray.map((item) => item.id));

    const additionalItems = passedArray.filter(
      (item) => idsToPush.includes(item.id) && !idsAlreadyIncluded.has(item.id)
    );

    filteredArray = [...filteredArray, ...additionalItems];
  }

  // Step 4: Emit result
  passedReplaySubject.next(filteredArray);
}

export function initYear() {
  const currentYear = new Date().getFullYear();
  const startYear = 2005;
  let allYears = [];
  for (let year = startYear; year <= currentYear + 1; year++) {
    allYears.push({ id: year, year: year.toString() });
  }
  return allYears;
}

export function random4DigitId() {
  return Math.floor(1000 + Math.random() * 9000);
}

export function filteredParams(fields: any) {
  let filters = [];
  Object.keys(fields).forEach((key) => {
    if (fields[key] != '') {
      let control = {};
      control[key] = fields[key];
      filters.push(control);
    }
  });

  return filters;
}

export function getFiltersEntity(key: string, isSession: boolean = false) {
  let applied_filter_entity = [];
  if (isSession) {
    applied_filter_entity = JSON.parse(sessionStorage.getItem(key) || '[]');
  } else {
    applied_filter_entity = JSON.parse(localStorage.getItem(key) || '[]');
  }
  let applied_filter_count = applied_filter_entity.length
    ? applied_filter_entity.length
    : null;

  return { applied_filter_entity, applied_filter_count };
}

export function getFiltersEntityValues(key: string, isSession: boolean = false) {
  let applied_filter_entity = [];
  let applied_filter = [];
  if (isSession) {
    applied_filter_entity = JSON.parse(sessionStorage.getItem(key) || '[]');
  } else {
    applied_filter_entity = JSON.parse(localStorage.getItem(key) || '[]');
  }
  applied_filter_entity = applied_filter_entity
  let applied_filter_count = applied_filter_entity.length
    ? applied_filter_entity.length
    : null;
  if (applied_filter_entity.length) {
    applied_filter_entity.forEach((element: { controlName: string; value: string }) => {
      if (element.controlName && element.value) {
        applied_filter.push({ [element.controlName]: element.value });
      }
    });
  }

  return { applied_filter_entity: applied_filter, applied_filter_count };
}


export function getAppliedFilters(key: string, isSession: boolean = false) {
  let applied_filter = '';
  let filters = [];
  if (isSession) {
    filters = JSON.parse(sessionStorage.getItem(key) || '[]');
  } else {
    filters = JSON.parse(localStorage.getItem(key) || '[]');
  }
  let applied_filter_count = filters.length ? filters.length : null;

  if (filters.length) {
    filters.forEach((element) => {
      Object.keys(element).forEach((key) => {
        applied_filter += `${key}=${element[key]}&`;
      });
    });
  }

  return { applied_filter, applied_filter_count };
}

export function getAppliedFiltersValue(key: string, isSession: boolean = false) {
  let applied_filter = '';
  let filters = isSession
    ? JSON.parse(sessionStorage.getItem(key) || '[]')
    : JSON.parse(localStorage.getItem(key) || '[]');

  let applied_filter_count = filters.length || null;
  if (filters.length) {
    filters.forEach((element: { controlName: string; value: string }) => {
      if (element.controlName && element.value) {
        applied_filter += `${element.controlName}=${element.value}&`;
      }
    });
  }
  return { applied_filter, applied_filter_count };
}

export function viewDocument(file: string) {
  if (!file) {
    this._toasterService.showError('ERROR', 'Invalid file path');
    return;
  }
  file = `${environment.fileBaseUrl}${file.replaceAll(' ', '+')}`;
  window.open(file);
}

export function viewDocumentV2(
  file: string,
  toasterService: any,
  translate: any
) {
  if (!file) {
    toasterService.showError(
      translate.instant('ERROR'),
      translate.instant('FILE_INVALID')
    );
    return;
  }

  const fileUrl = `${environment.fileBaseUrl}${file.replaceAll(' ', '+')}`;
  const fileExtension = file.split('.').pop()?.toLowerCase();

  if (['doc', 'docx', 'pdf'].includes(fileExtension)) {
    const googleDocsViewerUrl = 'https://docs.google.com/viewer?url=';
    const encodedFileUrl = encodeURIComponent(fileUrl);
    window.open(
      `${googleDocsViewerUrl}${encodedFileUrl}&embedded=true`,
      '_blank'
    );
  } else if (
    ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(fileExtension)
  ) {
    // For images, open in a new tab with the image displayed
    const imgWindow = window.open('', '_blank');
    imgWindow.document.write(`
          <img src="${fileUrl}" style="max-width: 100%; max-height: 100%; display: block; margin: auto;">
      `);
  } else {
    // For other file types, use the original method
    window.open(fileUrl, '_blank');
  }
}

export function validateUploadDoc(module: string, size?: number) {
  let file_size;
  let file_size_invalid;
  let file_accept;
  let file_not_allowed;

  let restrictions = JSON.parse(localStorage.getItem('upload_restrictions'));
  if (restrictions?.length) {
    let find_module = restrictions.find(
      (element) => element.module === module
    );
    if (find_module) {
      file_size = size ? fileSizeAndExtension(size).size : '';
      file_size_invalid = size / (1024 * 1024) >= find_module.size;
      file_accept = find_module?.extension?.toString();
    } else {
      file_not_allowed = true;
    }
  }

  return { file_size, file_size_invalid, file_accept, file_not_allowed };
}

export function fileSizeAndExtension(size: number, file_name?: string) {
  let file_size = size / (1024 * 1024);

  return {
    size: `${file_size.toFixed(2)} MB`,
    extension: file_name ? `.${file_name.split('.').pop()}` : '',
  };
}

export function specificUserParams(is_tenant?: boolean) {
  let user_details = JSON.parse(localStorage.getItem('roles_permissions'));
  let query: string = '';

  if (user_details?.length) {
    let params = user_details[0];
    if (params?.tenants?.length && !is_tenant) {
      query += `tenant=${params?.tenants[0]?.id}&`;
    }
    if (params?.subTenant?.length) {
      query += `subtenant=${params?.subTenant}&`;
    }
    if (params?.displayUsers?.length) {
      query += `displayUsers=${params?.displayUsers}&`;
    }
  }

  return query;
}

export function getMailReplyFormat(data: any, dynamicData?): any {
  // const signature = getSignatureV2();
  let signature = '';
  if (dynamicData) {
    signature = getSignature(dynamicData);
  } else {
    let user = JSON.parse(localStorage.getItem('user_details'));
    const defaultName = user?.name ?? 'User Name';
    signature = `<span style="color: #000000">Thanks and Regards,</span>
      <br />
      <strong><span style="color: #000000">${defaultName}</span></strong>`
  }
  let replyBody;
  // if(signature){
  replyBody = `
      <br />
      <br />
      <br />
      ${signature}
      <hr style="display:inline-block;width:98%" tabindex="-1">
      <br />
      <span dir="ltr" style="font-size: 12px;">
        <strong>From:</strong>  ${data?.mail_details?.from_name} ${'&lt;' + data?.mail_details?.from_mail + '&gt;'
    } <br />
        <strong>Sent:</strong> ${data?.mail_details?.assignDate}<br>
        <strong>To:</strong>  ${data?.mail_details?.name ? data?.mail_details?.name : ''
    } ${'&lt;' + data?.mail_details?.to_mail + '&gt;'} <br />
        ${getCC(data?.mail_details?.cc_mail)}
        ${getBCC(data?.mail_details?.bcc_mail)}
        <strong>Subject:</strong> ${data?.mail_details?.subject ?? ''}
      </span>
      <br />
      <br />
      <br />
       <span>
       ${data?.mail_details?.body}
       </span> 
      <br />
      `;
  // }
  return replyBody;
}

export function getReplyCommentFormat(data: any): any {
  // const signature = getSignatureV2();
  let signature = '';
  let replyBody;
  // if(signature){
  replyBody = `
    <br />
    <br />    
    <hr style="display:inline-block;width:98%" tabindex="-1">
    <br />
    <span dir="ltr" style="font-size: 12px;">
      <strong>From:</strong>  ${data?.mail_details?.from_name}<br>
      <strong>Sent:</strong> ${data?.mail_details?.assignDate}<br>
      <strong>To:</strong>  ${data?.mail_details?.to_name ? data?.mail_details?.to_name : getUsernamesFromEmails(data?.mail_details?.to_mail)
    }<br>

      ${data?.mail_details?.cc_mail ? '<strong>CC:</strong>' + getUsernamesFromEmails(data?.mail_details?.cc_mail) + '<br />' : ''}      
      ${data?.mail_details?.bcc_mail ? '<strong>BCC:</strong>' + getUsernamesFromEmails(data?.mail_details?.bcc_mail) + '<br />' : ''}
      <strong>Subject:</strong> ${data?.mail_details?.subject ?? ''}
    </span>
    <br />
    <br />
    <br />
    `;
  // }
  return replyBody;
}


export function getUsernamesFromEmails(emails: string): string {
  if (!emails) {
    return '';
  }

  // Process the emails: split, trim, validate, and extract usernames
  const usernames = emails.split(',')
    .map(email => email.trim()) // Remove extra spaces around each email
    .filter(email => email.includes('@')) // Filter out invalid entries
    .map(email => email.split('@')[0]); // Extract the username
  const capitalizedUsernames = usernames.map(username => capitalizeFirstLetter(username));

  // Return the formatted string with <strong>Cc:</strong> and the usernames
  return `${capitalizedUsernames.join(', ')}`;
}

export function capitalizeFirstLetter(str) {
  if (!str) return str; // Handle empty or undefined strings
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getCC(cc) {
  if (cc) {
    return `<strong>Cc:</strong> &lt;${cc ? '&lt;' + cc + '&gt;' : ''}<br>`;
  } else {
    return '';
  }
}

export function getBCC(bcc) {
  bcc = ''
  if (bcc) {
    return `<strong>Bcc:</strong> ${bcc ? '&lt;' + bcc + '&gt;' : ''} <br>`;
  } else {
    return '';
  }
}

export function userParams(module: string, is_tenant?: boolean) {
  let query = '';

  if (
    this._permissionPipe.transform(module, permissionEntity.access.read_all)
  ) {
    query += `displayType=readAll&`;
  } else {
    query += specificUserParams(is_tenant);
    query += `displayType=read&`;
  }
  return query;
}

export function fileLogo(file_name: string) {
  file_name = file_name?.toLowerCase();
  let extension = file_name.split('.').pop();
  let final_url = '';
  switch (extension) {
    case 'png':
      final_url = 'png.png';
      break;

    case 'jpg':
      final_url = 'jpg.png';
      break;

    case 'jpeg':
      final_url = 'jpeg.png';
      break;

    case 'pdf':
      final_url = 'pdf2.png';
      break;

    case 'txt':
      final_url = 'txt.png';
      break;

    case 'doc':
      final_url = 'doc.png';
      break;

    case 'xl4':
      final_url = 'xl4.png';
      break;

    case 'xlsx':
      final_url = 'xlsx.png';
      break;
  }

  return final_url;
}

export function filePathWithBaseURL(file: string) {
  file = `${environment.fileBaseUrl}${file?.replaceAll(' ', '+')}`;
  return file;
}

export function filePathWithProfileURL(file: string) {
  file = `${environment.fileProfileUrl}${file?.replaceAll(' ', '+')}`;
  return file;
}

export function filePathWithUserImageURL(file: string) {
  file = `${environment.fileUsersUrl}${file?.replaceAll(' ', '+')}`;
  return file;
}

export function fileType(file_name?: string) {
  let type = file_name.split('.').pop();
  let img_type = ['jpg', 'jpeg', 'png', 'svg'];
  return img_type.includes(type);
}

export function getMailDraftEditBody(data: any, dynamicData?): any {
  let replyBody = `
      ${data?.mail_details?.body}
    `;

  return replyBody;
}

export function calculateSize(file: any) {
  let total_byte = 0;
  let size_in_mb = 0;
  for (let val of file) {
    total_byte += val.size;
  }
  if (total_byte) {
    size_in_mb = total_byte / (1024 * 1024);
  }

  return size_in_mb;
}

export function random3DigitId() {
  return Math.floor(100 + Math.random() * 900);
}

export function getSignatureWithData(data: any, user: any, dynamicData): string {
  const defaultBody = data?.mail_details?.body || '';
  const defaultName = user?.name ?? 'User Name';
  const defaultJobTitle = user?.roles?.[0]?.name ?? 'Job Role';
  const defaultCompany = 'Crizac Limited';
  const phone = user?.phone ?? '-';
  const website = 'www.crizac.com';
  const email = user?.email ?? 'User Mail';
  const corporateOffice =
    'Constantia Building, Wing A, 11 Dr. U.N. Brahmachari Street, Kolkata 700017';
  const londonOffice = '24 Great Chapel Street, Soho London, UK. W1F 4FS';
  // const signature = getSignatureV2();
  const signature = getSignature(dynamicData);
  return `
    ${defaultBody}
    <br />
    ${signature}
  `;
}

export function getSignature(dynamicData): string {
  let user = JSON.parse(localStorage.getItem('user_details'));
  const defaultName = user?.name ?? 'User Name';
  const defaultJobTitle = user?.roles?.[0]?.name ?? 'Job Role';
  const defaultCompany = dynamicData?.companyName;
  // const defaultCompany = 'Crizac Limited';
  const phone = user?.phone ?? dynamicData?.companyPhone;
  // const phone =  user?.phone ?? '-';
  const website = dynamicData?.companyWebsite;
  // const website = 'www.crizac.com';
  const email = dynamicData?.email ?? 'User Mail';
  // const email = user?.email ?? 'User Mail';
  const corporateOffice = dynamicData?.companyAddress ??
    'Wing A, 3rd Floor, Constantia Building, 11 Dr. U.N. Brahmachari Street, Shakespeare Sarani, Kolkata - 700017';
  const londonOffice =
    '24 Great Chapel Street, Soho, London, England, W1F 8FS';
  const londonOfficeSection = dynamicData?.companyName == 'Crizac Limited' ? `<br />
    <strong><span style="color: #1e4f7e; font-size: 12px">London Office: </span></strong><span style="color: #000000; font-size: 12px">${londonOffice}</span
    >`: '';
  const companyImage = dynamicData?.companyImage ?? 'data:image/svg+xml;base64,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'
  return `<p></p>
<br />
<br />
<span style="color: #000000">Thanks and Regards,</span>
<br />
${defaultName ? `<strong><span style="color: #000000">${defaultName}</span></strong><br />
<br /> `: ''}

${defaultCompany ? `<strong><span style="color: #1e4f7e">${defaultCompany}</span></strong> <br />
<br />` : ''}

${companyImage ? `<img alt="" src="${companyImage}" style="height:65px; width:125px;" /><br /><br />` : ''}
<strong><span style="color: #1e4f7e; font-size: 12px">Mobile: </span></strong
><span style="color: #000000; font-size: 12px"
  ><a href="tel:-${phone || ''}"
    ><span style="color: #000000">${phone || ''}</span></a
  ></span
>
<br />
${website ? `<strong><span style="color: #1e4f7e; font-size: 12px">Website: </span></strong
><span style="color: #000000; font-size: 12px"><a
    href="https://${website}"
    target="_blank"><span style="color:#000000;">${website}</span></a></span><br />` : ''}
<strong><span style="color: #1e4f7e; font-size: 12px">Email: </span></strong
><span style="color: #000000; font-size: 12px"><a href="mailto:${email || ''}" target="_blank"><span
    style="color:#000000;">${email || ''}</span></a></span>
<br />
<br />
${corporateOffice ? `<strong
  ><span style="color: #1e4f7e; font-size: 12px"
    >Corporate Office:
  </span></strong
><span style="color: #000000; font-size: 12px"
  >${corporateOffice || ''}</span
>`  : ''}
${londonOfficeSection || ''}
<br />
<br />
<span style="color: #666666; font-size: 10px; font-weight: bold"
  >Disclaimer</span
>
<br />
<span style="color: #666666; font-size: 10px"
  >This email and any files transmitted with it are confidential and intended
  solely for the use of the individual or entity to whom they are addressed. If
  you have received this email in error, please notify the sender immediately,
  delete this email from your system and do not use, copy or disclose the
  information contained in this message or in any attachment.</span
>
`;
}

export function getSignatureV2(): string {
  let user = JSON.parse(localStorage.getItem('user_details'));
  const defaultName = user?.name ?? 'User Name';
  const defaultJobTitle = user?.roles?.[0]?.name ?? 'Job Role';
  const defaultCompany = 'Crizac Limited';
  const phone = user?.phone ?? '-';
  const website = 'www.crizac.com';
  const email = user?.email ?? 'User Mail';
  const corporateOffice =
    'Wing A, 3rd Floor, Constantia Building, 11 Dr. U.N. Brahmachari Street, Shakespeare Sarani, Kolkata - 700017';
  const londonOffice =
    '24 Great Chapel Street, Soho, London, England, W1F 8FS';

  return `
  <br/>
  <br/>
  <br/>
  <br/>
  <div
  style="
    font-family: Arial, sans-serif;
    font-size: 14px;
    color: #000;
    max-width: 100%;
/*    border: 1px solid #e1e1e1;*/
    border-radius: 5px;
    padding: 0;
    box-sizing: border-box;
  "
>
  <div style="display: flex; flex-wrap: nowrap">
    <!-- Left Sidebar -->
    <div
      style="
        flex: none;
        padding: 0px;
        box-sizing: border-box;
        display: inline-table;
        flex-direction: column;
        justify-content: center;
      "
    >
      <!-- Name -->
      <div style="font-size: 16px; font-weight: bold; color: #d22d2f; margin-right:10px">
        ${defaultName} 
      </div>
      <!-- Title -->
      <div style="font-size: 14px; color: #0073b1; margin-top: 5px">
         <!--IT Manager, -->
        ${defaultCompany}
      </div>
      <!-- Logo -->
     <img src='data:image/svg+xml;base64,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'
        alt="Crizac Logo"
        style="margin-top: 40px; max-width: 120px"
      />
    </div>

    <!-- Vertical Divider in the Middle -->
    <div
      style="
        width: 2px;
        background-color: #e1e1e1;
        margin: 10 20px;
        display: block;
      "
    ></div>

    <!-- Right Sidebar -->
    <div
      style="
        flex: 1;
        padding: 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
      "
    >
      <!-- Contact Information -->
      <div style="font-size: 14px; margin-bottom: 10px">
        <img src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMEgxLjcxNDI5QzEuMjU5NjMgMCAwLjgyMzU5MyAwLjE4MDYxMiAwLjUwMjEwMiAwLjUwMjEwM0MwLjE4MDYxMiAwLjgyMzU5NCAwIDEuMjU5NjMgMCAxLjcxNDI5VjE0LjI4NTdDMCAxNC43NDA0IDAuMTgwNjEyIDE1LjE3NjQgMC41MDIxMDIgMTUuNDk3OUMwLjgyMzU5MyAxNS44MTk0IDEuMjU5NjMgMTYgMS43MTQyOSAxNkg4QzguNDU0NjYgMTYgOC44OTA2OSAxNS44MTk0IDkuMjEyMTggMTUuNDk3OUM5LjUzMzY3IDE1LjE3NjQgOS43MTQyOSAxNC43NDA0IDkuNzE0MjkgMTQuMjg1N1YxLjcxNDI5QzkuNzE0MjkgMS4yNTk2MyA5LjUzMzY3IDAuODIzNTk0IDkuMjEyMTggMC41MDIxMDNDOC44OTA2OSAwLjE4MDYxMiA4LjQ1NDY2IDAgOCAwWk04LjU3MTQzIDE0LjI4NTdDOC41NzE0MyAxNC40MzczIDguNTExMjMgMTQuNTgyNiA4LjQwNDA2IDE0LjY4OThDOC4yOTY5IDE0Ljc5NjkgOC4xNTE1NSAxNC44NTcxIDggMTQuODU3MUgxLjcxNDI5QzEuNTYyNzMgMTQuODU3MSAxLjQxNzM5IDE0Ljc5NjkgMS4zMTAyMiAxNC42ODk4QzEuMjAzMDYgMTQuNTgyNiAxLjE0Mjg2IDE0LjQzNzMgMS4xNDI4NiAxNC4yODU3VjEuNzE0MjlDMS4xNDI4NiAxLjU2MjczIDEuMjAzMDYgMS40MTczOSAxLjMxMDIyIDEuMzEwMjJDMS40MTczOSAxLjIwMzA2IDEuNTYyNzMgMS4xNDI4NiAxLjcxNDI5IDEuMTQyODZIMi4yODU3MUMyLjI4NTcxIDEuMjk0NDEgMi4zNDU5MiAxLjQzOTc1IDIuNDUzMDggMS41NDY5MkMyLjU2MDI1IDEuNjU0MDggMi43MDU1OSAxLjcxNDI5IDIuODU3MTQgMS43MTQyOUg2Ljg1NzE0QzcuMDA4NyAxLjcxNDI5IDcuMTU0MDQgMS42NTQwOCA3LjI2MTIgMS41NDY5MkM3LjM2ODM3IDEuNDM5NzUgNy40Mjg1NyAxLjI5NDQxIDcuNDI4NTcgMS4xNDI4Nkg4QzguMTUxNTUgMS4xNDI4NiA4LjI5NjkgMS4yMDMwNiA4LjQwNDA2IDEuMzEwMjJDOC41MTEyMyAxLjQxNzM5IDguNTcxNDMgMS41NjI3MyA4LjU3MTQzIDEuNzE0MjlWMTQuMjg1N1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo='
          alt="Phone"
          style="vertical-align: middle; width: 9.71px; height: 16px"
          ;
        />
        <span style="margin-left: 5px">${phone}</span>
      </div>
      <div style="font-size: 14px; margin-bottom: 10px">
        <img src='data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjA0NjggMEgxLjk1NjU1QzAuODc3MzAxIDAgMCAwLjg3NzMwMSAwIDEuOTU2NTVWMTAuMjE5N0MwIDExLjI5OSAwLjg3NzMwMSAxMi4xNzYzIDEuOTU2NTUgMTIuMTc2M0gxNC4wNDM0QzE1LjEyMjcgMTIuMTc2MyAxNiAxMS4yOTkgMTYgMTAuMjE5N1YxLjk1OTg2QzE2LjAwMzMgMC44ODA2MTIgMTUuMTI2IDAgMTQuMDQ2OCAwWk0xNS4xMDk0IDEwLjIxOTdDMTUuMTA5NCAxMC44MDU3IDE0LjYzMjcgMTEuMjgyNCAxNC4wNDY4IDExLjI4MjRIMS45NTY1NUMxLjM3MDU4IDExLjI4MjQgMC44OTM4NTQgMTAuODA1NyAwLjg5Mzg1NCAxMC4yMTk3VjEuOTU5ODZDMC44OTM4NTQgMS4zNzM4OSAxLjM3MDU4IDAuODk3MTY1IDEuOTU2NTUgMC44OTcxNjVIMTQuMDQzNEMxNC42Mjk0IDAuODk3MTY1IDE1LjEwNjEgMS4zNzM4OSAxNS4xMDYxIDEuOTU5ODZWMTAuMjE5N0gxNS4xMDk0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEwLjA5MDYgNS45ODU0NEwxNC4wMDM3IDIuNDc2MjNDMTQuMTg1OCAyLjMxMDcgMTQuMjAyMyAyLjAyOTMgMTQuMDM2OCAxLjg0MzkxQzEzLjg3MTMgMS42NjE4MyAxMy41ODk5IDEuNjQ1MjggMTMuNDA0NSAxLjgxMDgxTDguMDA4MjQgNi42NTQxN0w2Ljk1NTQ4IDUuNzEzOTdDNi45NTIxNyA1LjcxMDY2IDYuOTQ4ODUgNS43MDczNSA2Ljk0ODg1IDUuNzA0MDRDNi45MjU2OCA1LjY4MDg2IDYuOTAyNTEgNS42NjEgNi44NzYwMiA1LjY0MTE0TDIuNTkyMTQgMS44MDc1QzIuNDA2NzUgMS42NDE5NyAyLjEyNTM1IDEuNjU4NTIgMS45NTk4MiAxLjg0MzkxQzEuNzk0MyAyLjAyOTMgMS44MTA4NSAyLjMxMDcgMS45OTYyNCAyLjQ3NjIzTDUuOTU1NjggNi4wMTUyM0wyLjAxMjc5IDkuNzA2NTJDMS44MzQwMiA5Ljg3NTM2IDEuODI0MDkgMTAuMTU2OCAxLjk5MjkzIDEwLjMzODhDMi4wODIzMSAxMC40MzE1IDIuMjAxNSAxMC40ODEyIDIuMzIwNjggMTAuNDgxMkMyLjQyOTkyIDEwLjQ4MTIgMi41MzkxNyAxMC40NDE1IDIuNjI1MjUgMTAuMzYyTDYuNjI3NzMgNi42MTc3Nkw3LjcxMzYgNy41ODc3NUM3Ljc5OTY3IDcuNjYzOSA3LjkwNTYxIDcuNzAwMzEgOC4wMTE1NSA3LjcwMDMxQzguMTE3NDkgNy43MDAzMSA4LjIyNjc0IDcuNjYwNTkgOC4zMDk1IDcuNTg0NDRMOS40MjUxNiA2LjU4NDY1TDEzLjQwNDUgMTAuMzY1M0MxMy40OTA1IDEwLjQ0ODEgMTMuNjAzMSAxMC40ODc4IDEzLjcxMjQgMTAuNDg3OEMxMy44MzE1IDEwLjQ4NzggMTMuOTQ3NCAxMC40NDE1IDE0LjAzNjggMTAuMzQ4OEMxNC4yMDU2IDEwLjE3IDE0LjE5OSA5Ljg4NTI5IDE0LjAyMDIgOS43MTY0NUwxMC4wOTA2IDUuOTg1NDRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K'
          alt="Email"
          style="vertical-align: middle; width: 12.8px; height: 16px"
          ;
        />
        <span style="margin-left: 5px">${email}</span>
      </div>
      <div style="font-size: 14px; margin-bottom: 10px">
       <img src='data:image/svg+xml;base64,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'
          alt="Website"
          style="vertical-align: middle; width: 16px; height: 16px"
          ;
        />
        <span style="margin-left: 5px">${website}</span>
      </div>
      <!-- Office Addresses -->
      <div style="display: flex">
        <div
          style="
            font-size: 14px;
            color: #0073b1;
            font-weight: bold;
            margin-top: 10px;
          "
        >
          Corporate office address: &nbsp;
        </div>
        <div style="font-size: 14px; margin-top: 10px">
         ${corporateOffice}
        </div>
      </div>
      
      <div style="display: flex">
      <div
        style="
          font-size: 14px;
          color: #0073b1;
          font-weight: bold;
          margin-top: 10px;
        "
      >
        London office address: &nbsp;
      </div>
       <div style="font-size: 14px; margin-top: 10px">
        ${londonOffice}
      </div>
    </div>
    </div>
  </div>
  <!-- Footer Note -->
  <div
    style="
      width: 877px;
      padding-top: 15px;
      text-align: start;
      font-size: 13px;
      line-height: 18px;
      color: #666;
      padding-left: 10px;
      font-weight: 400;
    "
  >
    <h6><span style="color:#666666;">Disclaimer</span></h6>
<h6><span style="color:#666666;">This email and any files transmitted with it are confidential and intended solely for
        the use of the individual or entity to whom they are addressed. If you have received this email in error, please
        notify the sender immediately, delete this email from your system and do not use, copy or disclose the
        information contained in this message or in any attachment.<br></span></h6>
  </div>
</div>

        
        `;
  // <img src="https://com-crizac-email.s3.eu-west-1.amazonaws.com/email-attachments/1ec3faed-0230-408c-aeae-4cf4e41c3b9d.me/I0/01020191e4ef53fd-89c84ebb-7c4d-49b2-8336-f9e31e6c947c-000000/rMd6RgCva2emw_qEGQzDgAn-9ho%3D391"
  //     alt="" />
  //   <p style="font-family: Verdana, sans-serif; color: #000000; font-size: 9px; font-style: italic;">
  //   I sent this email at a time that was convenient for me. Unless it's marked urgent, feel free to respond at your convenience. Work-life harmony is important.
  // </p>
}

export function decodeHtml(html: string) {
  // Create a temporary DOM element to decode HTML entities
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

// export function decodeComment(comment: string): string {
//   if (!comment) return '';

//   try {
//     // Only decode the URL encoding, preserve HTML tags
//     const decodedContent = decodeURIComponent(comment)
//       .replace(/\r\n/g, '\n')     // Normalize line endings
//       .replace(/\n\s*\n/g, '\n')  // Remove extra blank lines
//       .trim();                    // Remove leading/trailing whitespace

//     return decodedContent;

//   } catch (error) {
//     console.error('Error decoding comment:', error);
//     return comment;  // Return original if decoding fails
//   }
// }


// export function decodeComment(input) {
//   if (!input) {
//     return '';
//   }

//   let decodedText = input;

//   // Decode URL-encoded text
//   if (/%[0-9A-Fa-f]{2}/.test(input)) {
//     try {
//       decodedText = decodeURIComponent(input);
//     } catch (error) {
//       console.error('Error decoding URL-encoded text:', error);
//       return input;
//     }
//   }

//   // Store links temporarily
//   const links = [];
//   let linkCounter = 0;
//   decodedText = decodedText.replace(
//     /<a[^>]*href=["']([^"']+)["'][^>]*>(.*?)<\/a>/gi,
//     (match, url, text) => {
//       const placeholder = `__LINK${linkCounter}__`;
//       links.push({ placeholder, url, text });
//       linkCounter++;
//       return placeholder;
//     }
//   );

//   // Extract URLs that aren't in anchor tags
//   decodedText = decodedText.replace(
//     /(https?:\/\/[^\s<]+)/g,
//     (match) => {
//       const placeholder = `__LINK${linkCounter}__`;
//       links.push({ placeholder, url: match, text: match });
//       linkCounter++;
//       return placeholder;
//     }
//   );

//   // Remove HTML tags
//   decodedText = decodedText.replace(/<[^>]*>/g, '\n')
//     // Replace HTML entities
//     .replace(/&nbsp;/g, ' ')
//     .replace(/&amp;/g, '&')
//     .replace(/&lt;/g, '<')
//     .replace(/&gt;/g, '>')
//     .replace(/&quot;/g, '"')
//     .replace(/&#39;/g, "'")
//     // Clean up multiple newlines and spaces
//     .replace(/\n\s*\n/g, '\n\n')
//     .replace(/  +/g, ' ')
//     .trim();

//   // Restore links with target="_blank" and rel="noopener noreferrer"
//   links.forEach(({ placeholder, url, text }) => {
//     decodedText = decodedText.replace(
//       placeholder,
//       `<a href="${url}" target="_blank" rel="noopener noreferrer">${text}</a>`
//     );
//   });

//   return decodedText;
// }

export function decodeComment(input) {
  if (!input) {
    return '';
  }

  let decodedText = input;

  // Decode URL-encoded text while preserving HTML tags
  if (/%[0-9A-Fa-f]{2}/.test(input)) {
    try {
      // Store HTML tags temporarily
      const tags = [];
      let tagCounter = 0;

      decodedText = decodedText.replace(/<[^>]+>/g, (match) => {
        const placeholder = `__TAG${tagCounter}__`;
        tags.push({ placeholder, content: match });
        tagCounter++;
        return placeholder;
      });

      // Decode URL-encoded text
      decodedText = decodeURIComponent(decodedText);

      // Restore HTML tags
      tags.forEach(({ placeholder, content }) => {
        decodedText = decodedText.replace(placeholder, content);
      });
    } catch (error) {
      console.error('Error decoding URL-encoded text:', error);
      return input;
    }
  }

  // Replace HTML entities while preserving tags
  decodedText = decodedText
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");

  // Convert line breaks while preserving other formatting
  decodedText = decodedText
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    // Clean up multiple newlines and spaces without affecting HTML tags
    .replace(/(?<=>)\n\s*\n(?=<)/g, '\n\n')
    .replace(/(?<=>)\s{2,}(?=<)/g, ' ');

  // Extract URLs that aren't in anchor tags and convert them to links
  decodedText = decodedText.replace(
    /(?<!["'=])(https?:\/\/[^\s<]+)(?![^<]*>)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
  );

  return decodedText.trim();
}

export function hasEditAccessToCourses(roles_permissions: any[]): boolean {
  for (const role of roles_permissions) {
    for (const permission of role.permission) {
      if (permission.module === 'Courses' && permission.access.includes('edit')) {
        return true;
      }
    }
  }
  return false;
}


export function filterAllCountry(universityArr: any) {
  universityArr = universityArr.filter((v: any) => v?._id != '000');
  return universityArr;
}

export function filterOutActiveUniCountries(uniCountries, tenant) {
  uniCountries = uniCountries.filter((unC: any) => unC?.status == 'true');
  return uniCountries;
}

export function nonValidFields(items: FormControls, toasterService: any) {
  if (!items) {
    console.error('Items parameter is null or undefined');
    toasterService.showError(
      "Form is empty or undefined",
      'Check above field'
    );
    return;
  }
  const controls = items;
  let hasInvalidFields = false;

  for (const name in controls) {
    if (controls[name].invalid) {
      toasterService.showError(
        `${name} field must be present`,
        'Check above field'
      );
      hasInvalidFields = true;
    }
  }
}

export function isSizeBelowLimit(sizeString, limitInMB): any {
  if (sizeString && limitInMB) {
    // Split the size string into value and unit
    const [sizeValue, unit] = sizeString?.split(' ');

    // Convert the size to bytes
    let sizeInBytes;
    if (unit) {
      switch (unit?.toUpperCase()) {
        case 'KB':
          sizeInBytes = parseFloat(sizeValue) * 1024; // 1 KB = 1024 bytes
          break;
        case 'MB':
          sizeInBytes = parseFloat(sizeValue) * 1024 * 1024; // 1 MB = 1024 * 1024 bytes
          break;
        default:
          sizeInBytes = parseFloat(sizeValue) * 1024; // 1 KB = 1024 bytes

      }
    } else {
      sizeInBytes = parseFloat(sizeValue) * 1024; // 1 KB = 1024 bytes
    }


    // Convert the limit to bytes
    const limitInBytes = limitInMB * 1024 * 1024;

    // Check if the size is below the limit
    return sizeInBytes < limitInBytes;
  }
}

// Helper function to clean HTML and special characters from text
function cleanText(text: string = ''): string {
  // Remove HTML tags
  const withoutHtml = text.replace(/<[^>]*>/g, '');
  // Remove special characters and emojis
  const withoutSpecialChars = withoutHtml
    .replace(/[^\x20-\x7E]/g, '') // Remove non-printable ASCII characters
    .replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '') // Remove special characters
    .trim();
  return withoutSpecialChars;
}

export async function downloadAllAttachments(
  attachments: any = [],
  downloading: boolean = false,
  subject: string = ''
): Promise<void> {
  if (attachments.length === 0) return;

  try {
    // Create new JSZip instance
    const zip = new JSZip();

    // Fetch all files and add them to the zip
    const fetchPromises = attachments.map(async (attachment) => {
      const response = await fetch(attachment.filePath);
      const blob = await response.blob();
      zip.file(attachment.fileName, blob);
    });

    // Wait for all files to be fetched and added to zip
    await Promise.all(fetchPromises);

    // Generate the zip file
    const zipBlob = await zip.generateAsync({
      type: "blob",
      compression: "DEFLATE",
      compressionOptions: {
        level: 9 // Maximum compression
      }
    });

    // Clean subject text and create filename
    const cleanSubject = cleanText(subject);
    const zipFileName = cleanSubject
      ? `${cleanSubject.slice(0, 15)}.zip`
      : "attachments.zip";

    // Create download link
    const url = window.URL.createObjectURL(zipBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = zipFileName;

    // Trigger download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Cleanup
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error in download process:', error);
  }
}


export function printEmail(mailDetails: any) {
  const printWindow = window.open('', '_blank', 'height=600,width=800');
  if (!printWindow) {
    // alert('Please allow popups to print the email');
    return;
  }

  const styles = `
      <style>
          body {
              font-family: Arial, sans-serif;
              padding: 20px;
              max-width: 800px;
              margin: 0 auto;
          }
          a {
            text-decoration: none !important;
            color:rgb(1, 29, 43) !important;
          }
          .email-header {
              margin-bottom: 20px;
              border-bottom: 1px solid #ccc;
              padding-bottom: 15px;
          }
          .email-metadata {
              font-size: 14px;
              color: #666;
              margin-bottom: 5px;
          }
          .email-body {
              margin-top: 20px;
          }
          .attachments {
              margin-top: 20px;
              padding-top: 15px;
              border-top: 1px solid #eee;
          }
          .attachment-item {
              display: inline-flex;
              align-items: center;
              margin-right: 15px;
              margin-bottom: 10px;
              font-size: 13px;
              gap: 8px;
          }
          .attachment-icon {
              width: 24px;
              height: 24px;
              color: currentColor;
          }
          @media print {
              body {
                  padding: 15px;
              }
              .no-print {
                  display: none;
              }
          }
      </style>
  `;

  const attachmentIcon = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="attachment-icon">
          <path fill-rule="evenodd" d="M18.97 3.659a2.25 2.25 0 00-3.182 0l-10.94 10.94a3.75 3.75 0 105.304 5.303l7.693-7.693a.75.75 0 011.06 1.06l-7.693 7.693a5.25 5.25 0 11-7.424-7.424l10.939-10.94a3.75 3.75 0 115.303 5.304L9.097 18.835l-.008.008-.007.007-.002.002-.003.002A2.25 2.25 0 015.91 15.66l7.81-7.81a.75.75 0 011.061 1.06l-7.81 7.81a.75.75 0 001.054 1.068L18.97 6.84a2.25 2.25 0 000-3.182z" clip-rule="evenodd"/>
      </svg>
  `;

  const content = `
      <!DOCTYPE html>
      <html>
      <head>
          <title>${mailDetails.subject || 'Email Print'}</title>
          ${styles}
      </head>
      <body>
          <div class="email-header">
              <div class="email-metadata">
                  <strong>From:</strong> ${mailDetails.from_name || mailDetails.from_mail}
              </div>
              <div class="email-metadata">
                  <strong>To:</strong> ${mailDetails.to_mail || mailDetails.to_name}
              </div>
              ${mailDetails.cc_mail ? `
                  <div class="email-metadata">
                      <strong>CC:</strong> ${mailDetails.cc_mail}
                  </div>
              ` : ''}
              <div class="email-metadata">
                  <strong>Date:</strong> ${mailDetails.assignDate || mailDetails.timeStamp}
              </div>
              <div class="email-metadata">
                  <strong>Subject:</strong> ${mailDetails.subject || ''}
              </div>
          </div>
          
          <div class="email-body">
              ${mailDetails.body || mailDetails.mailBodyText || ''}
          </div>

          ${mailDetails.attachments?.length ? `
              <div class="attachments">
                  <strong>Attachments (${mailDetails.attachments.length}):</strong><br>
                  <div style="display: flex; flex-wrap: wrap; margin-top: 10px;">
                      ${mailDetails.attachments.map(attachment => `
                          <div class="attachment-item">
                              ${attachmentIcon}
                              ${attachment.fileName} (${attachment.formattedFileSize})
                          </div>
                      `).join('')}
                  </div>
              </div>
          ` : ''}

          <div class="no-print">
              <button onclick="window.print();return false;" 
                      style="margin-top: 20px; padding: 10px 20px; cursor: pointer;">
                  Print Email
              </button>
          </div>
      </body>
      </html>
  `;

  printWindow.document.write(content);
  printWindow.document.close();

  printWindow.onload = function () {
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
    }, 250);
  };
}

export function generateScoreList() {
  const scoreList: { id: number; scoreNumber: string }[] = [];
  for (let i = 0; i <= 300; i++) {
    const scoreValue = (1 + i / 2).toString();
    if (parseFloat(scoreValue) <= 150) {
      scoreList.push({
        id: i + 1,
        scoreNumber: scoreValue,
      });
    }
  }
  return scoreList;
}
export function getActualScore(englishScoreAPI: any, scoreList: any) {
  let englishScoreAPI_ = (parseInt(englishScoreAPI)-2)
    const foundElement_ = this.scoreList.find((element) => element.id === englishScoreAPI_ );
    console.log("foundElement",englishScoreAPI_,foundElement_,typeof(englishScoreAPI))
    return foundElement_ ? foundElement_.scoreNumber : undefined;
}

export function fileCheck(allfiles: any[], documentTypes: any[], DocumentList: any[], maxDocumentSize: number, currentStatus: boolean) {
  const messages: string[] = [];

  documentTypes.map(
    (permittedfileType) => {
      let documentType = DocumentList.find((v) => v?.enableToAutomationFileType === permittedfileType)?.enableToAutomationFileType
      let documentSize = DocumentList?.find((v) => v?.enableToAutomationFileType === permittedfileType)?.size

      if (!documentType) {
          messages.push(`** ${permittedfileType} is not present. Please update the ${permittedfileType}.`)
        }
        if (isSizeBelowLimit(documentSize, maxDocumentSize) === false) {
          messages.push(
            `** ${permittedfileType} size should be below ${maxDocumentSize} MB. Please update the${permittedfileType}.`
          );
        }
      
    }
  )
  
  allfiles.map(
    (allfilesdata) => {
      let documentformat = allfilesdata.extension?.toLowerCase().includes(".pdf")
      let documentSize = allfilesdata?.size
      let docName = allfilesdata?.enableToAutomationFileType;

      if(documentformat === false){
        messages.push(`** ${docName} is not pdf. Please update the ${docName}.`)
      }
      if (isSizeBelowLimit(documentSize, maxDocumentSize) === false) {
          messages.push(`** ${docName} is above size limit. Please check ${docName}.`)
          
      }
      
      
    }
  )

  if (currentStatus === false) {
    messages.push(
      ' Current Status must be Application Ok for Processing'
    );
  }

  return messages;

}
export function noOnlyWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  if (typeof value === 'string' && value.trim().length === 0) {
    return { whitespaceOnly: true };
  }
  return null;
}
export function noSpacesValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    if (!value || value.trim().length === 0 || /\s/.test(value)) {
      return { 'noSpaces': true };
    }
    return null;
  };
}

export function customEmailValidator(control: AbstractControl): ValidationErrors | null {
  const email = control.value;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/; // ensures something@something.domain

  if (email && !emailRegex.test(email)) {
    return { invalidEmail: true };
  }
  return null;
}
export function dateCompare(date1, date2){
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}